"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Socket = void 0;
var _socket = _interopRequireDefault(require("socket.io-client"));
/**
 * Create a socket.io socket object
 * @param {string} endpoint
 * @returns {*}
 * @private
 */
var _createSocket = function _createSocket(endpoint) {
  return (0, _socket["default"])(endpoint || _getSocketServerUrl(), {
    withCredentials: true,
    transports: ['polling', 'websocket'],
    reconnectionAttempts: 20 // Limits the number of reconnection attempts to prevent excessive attempts to reconnect. Default value is infinity
  });
};

var _getSocketServerUrl = function _getSocketServerUrl() {
  var _window = window,
    location = _window.location;
  var socketUrl = location.host;
  return socketUrl;
};

/**
 * Socket class
 * @param {string} endpoint
 */
var Socket = exports.Socket = function Socket(endpoint, token) {
  var _this = this;
  this._socket = _createSocket(endpoint, token);
  this._subscriptions = [];
  this.subscribeToEvent = function (eventId) {
    this.subscribe("event.".concat(eventId));
  };
  this.unsubscribeFromEvent = function (eventId) {
    this.unsubscribe("event.".concat(eventId));
  };
  this.subscribe = function (room, context) {
    if (this._subscriptions.includes(room)) return;
    this._subscriptions.push(room);
    this._socket.emit('subscribe', {
      room: room,
      context: context
    });
  };
  this.unsubscribe = function (room) {
    var indx = this._subscriptions.indexOf(room);
    if (indx === -1) return;
    this._subscriptions.splice(indx, 1);
    console.log("unsubscribing from ".concat(room));
    this._socket.emit('unsubscribe', {
      room: room
    });
  };
  this.on = this._socket.on.bind(this._socket);
  this.emit = this._socket.emit.bind(this._socket);
  this._socket.on('connect', function () {
    if (_this._socket.recovered) {
      console.log("Socket with ID: ".concat(_this._socket.id, " connected with recovery"));
    }
  });
  this._socket.io.on('reconnect', function () {
    console.log('socket reconnect event fired!');
    _this._subscriptions.forEach(function (room) {
      console.log("resubscribing to ".concat(room, " after reconnect."));
      _this._socket.emit('subscribe', {
        room: room
      });
    });
  });
  this._socket.on('connect_error', function (error) {
    console.error('Socket connection error:', error);
  });
  this.eject = function () {
    return _this._socket;
  };
  this.disconnect = function () {
    return _this._socket.disconnect();
  };
};